import axios from "axios";

export const ADMIN_SESSION_EVENT = "boroo-admin-session-expired";

const CSRF_HEADER_NAME = "X-CSRF-Token";

let csrfToken = null;

const instance = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

function isAdminScopedUrl(url = "") {
  return (
    url.startsWith("/admin") ||
    url.includes("/admin/") ||
    url.startsWith("/store-admin")
  );
}

function isCsrfProtectedMethod(method = "") {
  return ["post", "patch", "put", "delete"].includes(
    String(method).toLowerCase()
  );
}

function updateCsrfTokenFromResponse(response) {
  const headerToken = response?.headers?.[CSRF_HEADER_NAME.toLowerCase()];
  const bodyToken = response?.data?.csrf_token;

  if (headerToken) {
    csrfToken = headerToken;
    return;
  }

  if (bodyToken) {
    csrfToken = bodyToken;
  }
}

instance.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("boroo_device_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers["X-Device-Token"] = token;
    }
  } catch {}

  if (
    csrfToken &&
    isAdminScopedUrl(config.url || "") &&
    isCsrfProtectedMethod(config.method)
  ) {
    config.headers = config.headers || {};
    config.headers[CSRF_HEADER_NAME] = csrfToken;
  }

  return config;
});

instance.interceptors.response.use(
  (res) => {
    updateCsrfTokenFromResponse(res);
    return res;
  },
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const errorCode = error?.response?.data?.error;

    updateCsrfTokenFromResponse(error?.response);

    if (
      isAdminScopedUrl(url) &&
      errorCode !== "csrf_token_invalid" &&
      (status === 401 || status === 403) &&
      typeof window !== "undefined"
    ) {
      window.dispatchEvent(
        new CustomEvent(ADMIN_SESSION_EVENT, {
          detail: { status, url, data: error?.response?.data },
        })
      );
    }

    return Promise.reject(error);
  }
);

export default instance;
